import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BonusHistory } from '../../../core/models';
import { LaoDatePipe } from '../../lao-date.pipe';

/**
 * Bonus Details Modal Component
 * Displays comprehensive bonus information in a modal dialog
 */
@Component({
  selector: 'app-bonus-details-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, LaoDatePipe],
  templateUrl: './bonus-details-modal.component.html',
  styleUrl: './bonus-details-modal.component.scss'
})
export class BonusDetailsModalComponent {
  @Input() bonus: BonusHistory | null = null;
  @Input() isOpen: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  /**
   * Close the modal
   */
  onClose(): void {
    this.closeModal.emit();
  }

  /**
   * Close on backdrop click
   */
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.onClose();
    }
  }

  /**
   * Prevent closing when clicking inside modal
   */
  onModalClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  /**
   * Get status class for styling
   */
  getStatusClass(status: string): string {
    const statusLower = status?.toLowerCase() || '';
    
    if (statusLower.includes('approved') || statusLower.includes('paid')) {
      return 'approved';
    } else if (statusLower.includes('pending')) {
      return 'pending';
    } else if (statusLower.includes('rejected') || statusLower.includes('cancelled')) {
      return 'rejected';
    }
    
    return 'active';
  }

  /**
   * Get status icon
   */
  getStatusIcon(status: string): string {
    const statusLower = status?.toLowerCase() || '';
    
    if (statusLower.includes('approved') || statusLower.includes('paid')) {
      return 'fa-check-circle';
    } else if (statusLower.includes('pending')) {
      return 'fa-clock';
    } else if (statusLower.includes('rejected') || statusLower.includes('cancelled')) {
      return 'fa-times-circle';
    }
    
    return 'fa-circle-info';
  }
}
